import "./Navbar.css";
import Imagens from "../../IMAGESCOMPONENT/ImageComponent";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { verificaAdmin } from "../../utils/verificaAdmin";
import VerificaToken from "../../utils/VerificaToken";

function Navbar() {
  const navigate = useNavigate();

  const [busca, setBusca] = useState("");

  const [usuario, setUsuario] = useState({
    login: false,
  });

  const [qtdCarrinho, setQtdCarrinho] = useState(0);

  const isAdmin = verificaAdmin();

  function atualizarCarrinho() {
  const carrinho =
    JSON.parse(localStorage.getItem("carrinho")) || [];

  setQtdCarrinho(carrinho.length);
}

 useEffect(() => {
  async function atualizarTudo() {
    const dados = await VerificaToken();

    setUsuario(dados);
    atualizarCarrinho();
  }

  atualizarTudo();

  window.addEventListener(
    "storage",
    atualizarTudo
  );

  window.addEventListener(
    "carrinhoAtualizado",
    atualizarTudo
  );

  return () => {
    window.removeEventListener(
      "storage",
      atualizarTudo
    );

    window.removeEventListener(
      "carrinhoAtualizado",
      atualizarTudo
    );
  };
}, []);

  const handleBuscar = () => {
    if (busca.trim() !== "") {
      const termo = encodeURIComponent(
        busca.trim().replace(/\s+/g, "_")
      );

      navigate(`/busca/${termo}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleBuscar();
    }
  };

  const handleLogoutAdmin = () => {
    sessionStorage.removeItem("tokenAdmin");
    window.location.reload("/");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* LOGO */}
        <div
          className="navbar-logo"
          onClick={() => navigate("/")}
        >
          <img
            src={Imagens.Logo}
            alt="Eliandro Alimentos"
          />
        </div>

        {/* BUSCA */}
        <div className="navbar-search">
          <input
            type="text"
            placeholder="Buscar produto, marcas..."
            value={busca}
            onChange={(e) =>
              setBusca(e.target.value)
            }
            onKeyDown={handleKeyPress}
          />

          <button
            aria-label="Buscar"
            onClick={handleBuscar}
          >
            <svg viewBox="0 0 24 24">
              <circle
                cx="11"
                cy="11"
                r="8"
              />
              <line
                x1="21"
                y1="21"
                x2="16.65"
                y2="16.65"
              />
            </svg>
          </button>
        </div>

        {/* AÇÕES */}
        <div className="navbar-actions">
          {isAdmin ? (
            <button
              type="button"
              className="navbar-login"
              onClick={handleLogoutAdmin}
            >
              <svg viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                />
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
              </svg>

              <span>ADMIN</span>
            </button>
          ) : usuario.login ? (
            <button
             
              className="navbar-login"
              onClick={handleLogout}
            >
              <svg viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                />
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
              </svg>

              <span>Sair</span>
            </button>
          ) : (
            <a
              href="/login"
              className="navbar-login"
            >
              <svg viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="8"
                  r="4"
                />
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
              </svg>

              <span>Entre</span>
            </a>
          )}

          <a
            href={
              usuario.login
                ? "/dados"
                : "/cadastro"
            }
            className="navbar-register"
          >
            {usuario.login
              ? "Minha Empresa"
              : "Cadastre-se"}
          </a>

          {usuario.login && (
            <button
              className="navbar-cart"
              onClick={() =>
                navigate("/carrinho")
              }
              type="button"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle
                  cx="9"
                  cy="20"
                  r="1"
                />
                <circle
                  cx="18"
                  cy="20"
                  r="1"
                />
                <path d="M3 4h2l2.4 12.5a2 2 0 0 0 2 1.5h7.7a2 2 0 0 0 2-1.6L21 7H7" />
              </svg>

              {qtdCarrinho > 0 && (
                <span className="navbar-cart-badge">
                  {qtdCarrinho}
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;